import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';

/** @category Entities and Profiles */
export function useProfiles() {
  const tokenizedApi = useTokenizedApi();
  const profiles = useQuery(tokenizedApi.entities.profilesQuery());
  return profiles?.data?.allProfiles;
}
